import AllRecruitersDealTemplates from "../../components/recruiter-deal-templates";

const RecruitersDealTemplates = () => <AllRecruitersDealTemplates />
export default RecruitersDealTemplates;